import type { FC, Ref } from "react";

import {
  CheckboxGroup,
  type CheckboxGroupProps,
} from "../../../components/CheckboxGroup";
import { Spacing } from "../../../components";

export type CheckboxGroupProxyProps = Omit<
  CheckboxGroupProps,
  "value" | "onChange" | "options"
> & {
  value?: string[];
  onChange?: (value: string[]) => void;
  options?: {
    label: string;
    value: string;
  }[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const CheckboxGroupProxy: FC<CheckboxGroupProxyProps> = ({
  value,
  options,
  ref,
  ...props
}) => (
  <>
    <Spacing />
    <CheckboxGroup
      value={value ?? []}
      options={options ?? []}
      {...props}
      orientation="horizontal"
      ref={ref}
    />
    <Spacing />
  </>
);
